import { TokboxVolumeListener } from '../../tokbox-volume-listener';
import { TokboxMicrophoneRenderer } from '../../tokbox-microphone-renderer';
import { BASE64_PREFIX } from '../../../../../modules/core/constants';
import { get } from 'lodash';
import { RootScopeEvents } from '../../../../../common/services/root-scope-types';
import * as call from '../../../../../modules/call';
export default class TokboxScreenStream {
    constructor(personConnection, stream) {
        this.personConnection = personConnection;
        this.stream = stream;
        this.type = 'screen';
        this.isWaiting = true;
        this.$timeout = this.personConnection.$injector.get('$timeout');
        this.$rootScope = this.personConnection.$injector.get('$rootScope');
        this.$rootScope.$emit('stream:created', this);
        this.createSubscriber();
        this.setUpVideoElement();
        this.setUpVolumeListener();
        this.subscriber.on('loaded', () => {
            this.$rootScope.$emit('otSubscriberCreated', this.subscriber);
        });
        this.subscriber.on('destroyed', () => {
            this.$rootScope.$emit('otSubscriberDestroyed', this.subscriber);
            if (this.subscriber.stream)
                this.unsubscribe();
        });
    }
    get id() {
        return this.stream.id;
    }
    get volumeLevel() {
        return this.stream.volumeLevel || 0;
    }
    get hasAudio() {
        return get(this, 'subscriber.stream.hasAudio', false);
    }
    get hasVideo() {
        return get(this, 'subscriber.stream.hasVideo', false);
    }
    get isVideoElMuted() {
        const videoEl = this.getVideoElement();
        if (!videoEl)
            return false;
        return call.helpers.isSoundPlaying(videoEl);
    }
    getImgData() {
        if (!this.subscriber || !this.subscriber.isSubscribing())
            return;
        return BASE64_PREFIX + this.subscriber.getImgData();
    }
    async getStats() {
        return { audio: null, video: null };
    }
    getVideoElement() {
        return this.subscriber.videoElement();
    }
    destroy() {
        this.unsubscribe();
    }
    unsubscribe() {
        this.personConnection.session.unsubscribe(this.subscriber);
    }
    unmuteVideoEl() {
        const videoEl = this.getVideoElement();
        call.helpers.resumeSoundPlayback(videoEl);
        this.$rootScope.$emit(RootScopeEvents.STREAM.UNMUTE_VIDEO_EL);
    }
    createSubscriber() {
        const props = {
            insertDefaultUI: false,
        };
        this.subscriber = this.personConnection.session.subscribe(this.stream, null, props, (err) => {
            if (err) {
                this.$rootScope.$emit(RootScopeEvents.STREAM.SUBSCRIPTION_ERROR, {
                    stream: this,
                    event: err,
                });
            }
        });
    }
    setUpVolumeListener() {
        this.subscriber.on('loaded', () => {
            this.$rootScope.$emit('otSubscriberCreated', this.subscriber);
            const volumeListener = new TokboxVolumeListener(this.subscriber);
            const microphoneRenderer = new TokboxMicrophoneRenderer(this.stream.id, this.$rootScope);
            volumeListener.events.on('update', (level) => {
                this.stream.volumeLevel = level;
                microphoneRenderer.renderMicrophone(level);
            });
        });
    }
    setUpVideoElement() {
        this.videoElementPromise = new Promise((resolve) => {
            this.subscriber.on('videoElementCreated', (event) => {
                this.videoElement = this.subscriber.videoElement();
                this.$timeout(() => {
                    this.isWaiting = false;
                    this.$rootScope.$emit(RootScopeEvents.STREAM.VIDEO_ELEMENT_CREATED, this);
                    resolve(this.videoElement);
                });
            });
        });
    }
}
